import { LocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IBaseModel } from '../models/base.model';
import { BaseService } from './base.service';
import { Observable, Subject } from 'rxjs';
import { IOsaExecucaoProgramaTrabalhoModel, IOsaExecucaoProgramaTrabalhoQuestaoModel, IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel, IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoArquivoModel, IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel, IMatrizRiscoControleRiscosModel, IMatrizRiscoControleAssociadosModel, IOsaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoModel, IOsaExecucaoProgramaTrabalhoQuestaoIncidentalCausaModel, IOsaExecucaoProgramaTrabalhoQuestaoIncidentalConsequenciaModel, IOsaExecucaoProgramaTrabalhoQuestaoIncidentalControleModel, IOsaExecucaoProgramaTrabalhoQuestaoIncidentalTecnicaAuditoriaModel, IOsaExecucaoProgramaTrabalhoQuestaoIncidentalProcedModel, IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoAgrupadaModel } from '../models/osa-execucao-programa-trabalho.model';
import { IOsaExecucaoProgramaTrabalhoImprimirModel } from '../models/osa-execucao-programa-trabalho-imprimir.model';

@Injectable({
  providedIn: 'root',
})
export class OsaExecucaoProgramaTrabalhoService extends BaseService {

  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  //#region ProgramaTrabalho

  public obterProgramaTrabalhoPorExecucao(osaExecucaoId: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoModel[]>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoModel[]>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/osaExecucaoid/${osaExecucaoId}`)
      .toPromise();
  }

  public async obterProgramaTrabalhoPorId(id: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoModel>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/id/${id}`)
      .toPromise();
  }

  public async inserirProgramaTrabalho(data: IOsaExecucaoProgramaTrabalhoModel): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoModel>> {
    return this.httpClient
      .post<IBaseModel<IOsaExecucaoProgramaTrabalhoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho`, data)
      .toPromise();
  }

  public atualizarProgramaTrabalho(data: IOsaExecucaoProgramaTrabalhoModel): Observable<IBaseModel<IOsaExecucaoProgramaTrabalhoModel>> {
    return this.httpClient.put<IBaseModel<IOsaExecucaoProgramaTrabalhoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho`, data)
  }

  public async desabilitarProgramaTrabalho(data: IOsaExecucaoProgramaTrabalhoModel): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoModel>> {
    return this.httpClient
      .put<IBaseModel<IOsaExecucaoProgramaTrabalhoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/desabilitar-programa-trabalho`, data)
      .toPromise();
  }

  public async habilitarProgramaTrabalho(data: IOsaExecucaoProgramaTrabalhoModel): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoModel>> {
    return this.httpClient
      .put<IBaseModel<IOsaExecucaoProgramaTrabalhoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/habilitar-programa-trabalho`, data)
      .toPromise();
  }

  public async excluirProgramaTrabalho(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/${id}/excluir-programa-trabalho`)
      .toPromise();
  }

  public async imprimirProgramaTrabalho(id: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoImprimirModel>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoImprimirModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/${id}/imprimir-programa-trabalho`)
      .toPromise();
  }

  //#endregion


  //#region ProgramaTrabalhoQuestao

  public async obterProgramaTrabalhoQuestaoPorProgramaTrabalho(osaExecucaoProgramaTrabalhoId: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoModel[]>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoModel[]>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/osaExecucaoProgramaTrabalhoId/${osaExecucaoProgramaTrabalhoId}`)
      .toPromise();
  }

  public obterProgramaTrabalhoQuestaoPorId(Id: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoModel>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/id/${Id}`)
      .toPromise();
  }

  public inserirProgramaTrabalhoQuestao(data: IOsaExecucaoProgramaTrabalhoQuestaoModel): Observable<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoModel>> {
    return this.httpClient.post<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao`, data);
  }

  public async atualizarProgramaTrabalhoQuestao(data: IOsaExecucaoProgramaTrabalhoQuestaoModel): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoModel>> {
    return this.httpClient.put<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao`, data)
      .toPromise();
  }

  public async inserirProgramaTrabalhoQuestaoIncidental(data: IOsaExecucaoProgramaTrabalhoQuestaoModel): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoModel>> {
    return this.httpClient.post<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao-incidental`, data)
      .toPromise();
  }

  public async atualizarProgramaTrabalhoQuestaoIncidental(data: IOsaExecucaoProgramaTrabalhoQuestaoModel): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoModel>> {
    return this.httpClient.put<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao-incidental`, data)
      .toPromise();
  }

  public async excluirProgramaTrabalhoQuestaoIncidental(id: number): Promise<IBaseModel<void>> {
    return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/${id}/excluir-programa-trabalho-questao-incidental`)
      .toPromise();
  }

  //#endregion


  //#region ProgramaTrabalhoQuestaoIncidentalRisco

  public obterProgramaTrabalhoQuestaoIncidentalRiscoPorProgramaTrabalhoQuestao(osaExecucaoProgramaTrabalhoQuestaoId: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoModel[]>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoModel[]>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/risco/osaExecucaoProgramaTrabalhoQuestaoId/${osaExecucaoProgramaTrabalhoQuestaoId}`)
      .toPromise();
  }

  public obterProgramaTrabalhoQuestaoIncidentalRiscoPorId(Id: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoModel>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/risco/id/${Id}`)
      .toPromise();
  }

  public inserirProgramaTrabalhoQuestaoIncidentalRisco(data: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoModel): Observable<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoModel>> {
    return this.httpClient.post<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/risco`, data);
  }

  public excluirProgramaTrabalhoQuestaoIncidentalRisco(id: number): Observable<IBaseModel<void>> {
    return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/${id}/excluir-programa-trabalho-questao-incidental-risco`)
  }
  //#endregion  


  //#region ProgramaTrabalhoQuestaoIncidentalCausa

  public obterProgramaTrabalhoQuestaoIncidentalCausaPorProgramaTrabalhoQuestao(osaExecucaoProgramaTrabalhoQuestaoId: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalCausaModel[]>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalCausaModel[]>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/causa/osaExecucaoProgramaTrabalhoQuestaoId/${osaExecucaoProgramaTrabalhoQuestaoId}`)
      .toPromise();
  }

  public obterProgramaTrabalhoQuestaoIncidentalCausaPorId(Id: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalCausaModel>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalCausaModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/causa/id/${Id}`)
      .toPromise();
  }

  public inserirProgramaTrabalhoQuestaoIncidentalCausa(data: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalCausaModel): Observable<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalCausaModel>> {
    return this.httpClient.post<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalCausaModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/causa`, data);
  }

  public excluirProgramaTrabalhoQuestaoIncidentalCausa(id: number): Observable<IBaseModel<void>> {
    return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/${id}/excluir-programa-trabalho-questao-incidental-causa`)
  }
  //#endregion  


  //#region ProgramaTrabalhoQuestaoIncidentalConsequencia

  public obterProgramaTrabalhoQuestaoIncidentalConsequenciaPorProgramaTrabalhoQuestao(osaExecucaoProgramaTrabalhoQuestaoId: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalConsequenciaModel[]>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalConsequenciaModel[]>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/consequencia/osaExecucaoProgramaTrabalhoQuestaoId/${osaExecucaoProgramaTrabalhoQuestaoId}`)
      .toPromise();
  }

  public obterProgramaTrabalhoQuestaoIncidentalConsequenciaPorId(Id: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalConsequenciaModel>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalConsequenciaModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/consequencia/id/${Id}`)
      .toPromise();
  }

  public inserirProgramaTrabalhoQuestaoIncidentalConsequencia(data: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalConsequenciaModel): Observable<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalConsequenciaModel>> {
    return this.httpClient.post<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalConsequenciaModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/consequencia`, data);
  }

  public excluirProgramaTrabalhoQuestaoIncidentalConsequencia(id: number): Observable<IBaseModel<void>> {
    return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/${id}/excluir-programa-trabalho-questao-incidental-consequencia`)
  }
  //#endregion  


  //#region ProgramaTrabalhoQuestaoIncidentalControle

  public obterProgramaTrabalhoQuestaoIncidentalControlePorProgramaTrabalhoQuestao(osaExecucaoProgramaTrabalhoQuestaoId: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalControleModel[]>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalControleModel[]>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/controle/osaExecucaoProgramaTrabalhoQuestaoId/${osaExecucaoProgramaTrabalhoQuestaoId}`)
      .toPromise();
  }

  public obterProgramaTrabalhoQuestaoIncidentalControlePorId(Id: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalControleModel>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalControleModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/controle/id/${Id}`)
      .toPromise();
  }

  public inserirProgramaTrabalhoQuestaoIncidentalControle(data: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalControleModel): Observable<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalControleModel>> {
    return this.httpClient.post<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalControleModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/controle`, data);
  }

  public excluirProgramaTrabalhoQuestaoIncidentalControle(id: number): Observable<IBaseModel<void>> {
    return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/${id}/excluir-programa-trabalho-questao-incidental-controle`)
  }
  //#endregion  


  //#region ProgramaTrabalhoQuestaoIncidentalTecnicaAuditoria

  public obterProgramaTrabalhoQuestaoIncidentalTecnicaAuditoriaPorProgramaTrabalhoQuestao(osaExecucaoProgramaTrabalhoQuestaoId: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalTecnicaAuditoriaModel[]>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalTecnicaAuditoriaModel[]>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/tecnica-auditoria/osaExecucaoProgramaTrabalhoQuestaoId/${osaExecucaoProgramaTrabalhoQuestaoId}`)
      .toPromise();
  }

  public obterProgramaTrabalhoQuestaoIncidentalTecnicaAuditoriaPorId(Id: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalTecnicaAuditoriaModel>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalTecnicaAuditoriaModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/tecnica-auditoria/id/${Id}`)
      .toPromise();
  }

  public inserirProgramaTrabalhoQuestaoIncidentalTecnicaAuditoria(data: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalTecnicaAuditoriaModel): Observable<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalTecnicaAuditoriaModel>> {
    return this.httpClient.post<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalTecnicaAuditoriaModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/tecnica-auditoria`, data);
  }

  public excluirProgramaTrabalhoQuestaoIncidentalTecnicaAuditoria(id: number): Observable<IBaseModel<void>> {
    return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/${id}/excluir-programa-trabalho-questao-incidental-tecnica-auditoria`)
  }
  //#endregion  


  //#region ProgramaTrabalhoQuestaoIncidentalProced

  public obterProgramaTrabalhoQuestaoIncidentalProcedPorProgramaTrabalhoQuestao(osaExecucaoProgramaTrabalhoQuestaoId: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalProcedModel[]>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalProcedModel[]>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/proced/osaExecucaoProgramaTrabalhoQuestaoId/${osaExecucaoProgramaTrabalhoQuestaoId}`)
      .toPromise();
  }

  public obterProgramaTrabalhoQuestaoIncidentalProcedPorId(Id: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalProcedModel>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalProcedModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/proced/id/${Id}`)
      .toPromise();
  }

  public inserirProgramaTrabalhoQuestaoIncidentalProced(data: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalProcedModel): Observable<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalProcedModel>> {
    return this.httpClient.post<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoIncidentalProcedModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/incidental/proced`, data);
  }

  public excluirProgramaTrabalhoQuestaoIncidentalProced(id: number): Observable<IBaseModel<void>> {
    return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/${id}/excluir-programa-trabalho-questao-incidental-proced`)
  }
  //#endregion  


  //#region ProgramaTrabalhoQuestaoPapelTrabalho

  public obterProgramaTrabalhoQuestaoPapelTrabalhoPorProgramaTrabalhoQuestao(osaExecucaoProgramaTrabalhoQuestaoId: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel[]>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel[]>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/papel-trabalho/osaExecucaoProgramaTrabalhoQuestaoId/${osaExecucaoProgramaTrabalhoQuestaoId}`)
      .toPromise();
  }

  public obterProgramaTrabalhoQuestaoPapelTrabalhoPorId(Id: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/papel-trabalho/id/${Id}`)
      .toPromise();
  }

  public inserirProgramaTrabalhoQuestaoPapelTrabalho(data: IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel): Observable<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel>> {
    return this.httpClient.post<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/papel-trabalho`, data);
  }

  public atualizarProgramaTrabalhoQuestaoPapelTrabalho(data: IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel): Observable<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel>> {
    return this.httpClient.put<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/papel-trabalho`, data)
  }

  public excluirProgramaTrabalhoQuestaoPapelTrabalho(id: number): Observable<IBaseModel<void>> {
    return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/${id}/excluir-programa-trabalho-questao-papel-trabalho`)
  }

  //#endregion  


  //#region ProgramaTrabalhoQuestaoPapelTrabalhoArquivo

  public obterProgramaTrabalhoQuestaoPapelTrabalhoArquivoPorProgramaTrabalhoQuestaoPapelTrabalho(osaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoId: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoArquivoModel[]>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoArquivoModel[]>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/papel-trabalho/arquivo/osaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoId/${osaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoId}`)
      .toPromise();
  }

  public obterProgramaTrabalhoQuestaoPapelTrabalhoArquivoPorId(Id: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoArquivoModel>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoArquivoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/papel-trabalho/arquivo/id/${Id}`)
      .toPromise();
  }

  public inserirProgramaTrabalhoQuestaoPapelTrabalhoArquivo(data: IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoArquivoModel): Observable<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoArquivoModel>> {
    return this.httpClient.post<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoArquivoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/papel-trabalho/arquivo`, data);
  }

  public atualizarProgramaTrabalhoQuestaoPapelTrabalhoArquivo(data: IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoArquivoModel): Observable<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoArquivoModel>> {
    return this.httpClient.put<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoPapelTrabalhoArquivoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/papel-trabalho/arquivo`, data)
  }

  public excluirProgramaTrabalhoQuestaoPapelTrabalhoArquivo(id: number): Observable<IBaseModel<void>> {
    return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/${id}/excluir-programa-trabalho-questao-papel-trabalho-arquivo`)
  }

  //#endregion  


  //#region ProgramaTrabalhoQuestaoConstatacao

  public obterProgramaTrabalhoQuestaoConstatacaoPorProgramaTrabalhoQuestao(osaExecucaoProgramaTrabalhoQuestaoId: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel[]>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel[]>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/constatacao/osaExecucaoProgramaTrabalhoQuestaoId/${osaExecucaoProgramaTrabalhoQuestaoId}`)
      .toPromise();
  }

  public obterProgramaTrabalhoQuestaoConstatacaoPorId(Id: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/constatacao/id/${Id}`)
      .toPromise();
  }

  public inserirProgramaTrabalhoQuestaoConstatacao(data: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel): Observable<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel>> {
    return this.httpClient.post<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/constatacao`, data);
  }

  public atualizarProgramaTrabalhoQuestaoConstatacao(data: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel): Observable<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel>> {
    return this.httpClient.put<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/constatacao`, data)
  }

  public excluirProgramaTrabalhoQuestaoConstatacao(id: number): Observable<IBaseModel<void>> {
    return this.httpClient.delete<IBaseModel<void>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/${id}/excluir-programa-trabalho-questao-constatacao`)
  }

  public obterRiscosPorPlanejamentoUgQuestao(planejamentoId: number, unidadeGestoraId: number, questaoPlanejamentoId: number): Promise<IBaseModel<IMatrizRiscoControleRiscosModel[]>> {
    return this.httpClient
      .get<IBaseModel<IMatrizRiscoControleRiscosModel[]>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/obter-risco/planejamentoId/${planejamentoId}/unidadeGestoraId/${unidadeGestoraId}/questaoPlanejamentoId/${questaoPlanejamentoId}`)
      .toPromise();
  }

  public obterControlesPorPlanejamentoUgQuestao(planejamentoId: number, unidadeGestoraId: number, questaoPlanejamentoId: number): Promise<IBaseModel<IMatrizRiscoControleAssociadosModel[]>> {
    return this.httpClient
      .get<IBaseModel<IMatrizRiscoControleAssociadosModel[]>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/obter-controle/planejamentoId/${planejamentoId}/unidadeGestoraId/${unidadeGestoraId}/questaoPlanejamentoId/${questaoPlanejamentoId}`)
      .toPromise();
  }

  public obterProximoIdentificador(osaExecucaoProgramaTrabalhoId: number): Promise<IBaseModel<string>> {
    return this.httpClient
      .get<IBaseModel<string>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/constatacao/proximo/${osaExecucaoProgramaTrabalhoId}`)
      .toPromise();
  }

  public obterProgramaTrabalhoQuestaoConstatacaoPorProgramaTrabalho(osaExecucaoProgramaTrabalhoId: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoAgrupadaModel[]>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoAgrupadaModel[]>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao/constatacao/osaExecucaoProgramaTrabalhoId/${osaExecucaoProgramaTrabalhoId}`)
      .toPromise();
  }

  public obterQuestoesIncidentaisDoPlanejamento(osaExecucaoProgramaTrabalhoId: number): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoModel[]>> {
    return this.httpClient
      .get<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoModel[]>>(`${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao-incidental/planejamento/osaExecucaoProgramaTrabalhoid/${osaExecucaoProgramaTrabalhoId}`)
      .toPromise();
  }

  /**
   * Reaproveita uma questão incidental já existente (Crit 15 - HU reuso com edição):
   * preserva o identificador/descricao/criterio/fontes da origem, mas a nova cópia pode ter
   * Técnicas, Riscos, Causas, Consequências, Controles, Tipo dos Testes, Amostra e
   * Procedimentos diferentes (editados em tela). As coleções editadas são enviadas;
   * se omitidas (null/undefined) o backend copia integral da origem (compatibilidade).
   *
   * Controller: [HttpPost("programa-trabalho/questao-incidental/reutilizar")]
   * espera [FromBody] InserirIncidentalExistenteRequest.
   */
  public inserirIncidentalExistente(
    osaExecucaoProgramaTrabalhoQuestaoOrigemId: number,
    osaExecucaoProgramaTrabalhoDestinoId: number,
    amostraVinculadaId: number,
    tipoTeste?: number,
    riscos?: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalRiscoModel[],
    causas?: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalCausaModel[],
    consequencias?: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalConsequenciaModel[],
    controles?: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalControleModel[],
    tecnicasAuditoria?: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalTecnicaAuditoriaModel[],
    procedimentos?: IOsaExecucaoProgramaTrabalhoQuestaoIncidentalProcedModel[]
  ): Promise<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoModel>> {

    const request: any = {
      osaExecucaoProgramaTrabalhoQuestaoOrigemId,
      osaExecucaoProgramaTrabalhoDestinoId,
      amostraVinculadaId
    };
    if (tipoTeste !== undefined && tipoTeste !== null) request.tipoTeste = tipoTeste;
    //-> Crit 15: envia as listas editadas em tela (mesmo vazias); null = copiar da origem
    if (riscos !== undefined && riscos !== null) request.riscos = riscos;
    if (causas !== undefined && causas !== null) request.causas = causas;
    if (consequencias !== undefined && consequencias !== null) request.consequencias = consequencias;
    if (controles !== undefined && controles !== null) request.controles = controles;
    if (tecnicasAuditoria !== undefined && tecnicasAuditoria !== null) request.tecnicasAuditoria = tecnicasAuditoria;
    if (procedimentos !== undefined && procedimentos !== null) request.procedimentos = procedimentos;

    return this.httpClient
      .post<IBaseModel<IOsaExecucaoProgramaTrabalhoQuestaoModel>>(
        `${this.apiBaseUrl}/OsaExecucaoProgramaTrabalho/programa-trabalho/questao-incidental/reutilizar`,
        request
      )
      .toPromise();
  }

  //#endregion  

}
